import Axios from 'axios';

export default {
    getTournamentsEvents(sport) {
        const url = sport === "All Sports" 
            ? `/api/liveinplay/allactivesportsevents` 
            : `/api/liveinplay/sportfixtures/${sport}/tournamentsevents`;

        return Axios.get(url)
            .then(response => response.data)
            .catch(error => {
            console.error("Error fetching tournaments events:", error);
            });
    }
}